<div class="page-container">
  <h1><span *ngIf="evidenceTypeRouter == 'mrr'">Material Risk </span>Evidence</h1>
  <div class="question-options-row">
    <div class="filter-chips">
      <div class="chipDrop">
        <mat-chip-list aria-label="Filters">
          <mat-chip (click)=selectAssessment.open() color="primary" selected>
            {{(selectedAssessment ? selectedAssessment : 'All Assessments') | unescape}} <fa-icon [icon]="faSortDown">
            </fa-icon>
          </mat-chip>
        </mat-chip-list>
        <mat-select #selectAssessment class="optionsDropDown" [(value)]="selectedAssessment">
          <mat-option>
            <ngx-mat-select-search [clearSearchInput]="true" [searching]="surveysSearching"
              placeholderLabel="Search by Assessment Title.." [noEntriesFoundLabel]="noEntries" name="searchValue"
              #searchValue ngModel (ngModelChange)="findSurveys($event)"></ngx-mat-select-search>
          </mat-option>
          <mat-option (click)="resetPagination(); assessmentFilter('')" [value]="">
            All Assessments
          </mat-option>
          <mat-option [disabled]="searching" *ngFor="let returnedSurvey of surveysReturned" [value]="returnedSurvey"
            (click)="resetPagination(); assessmentFilter(returnedSurvey)">
            {{returnedSurvey | unescape}}
          </mat-option>
        </mat-select>
      </div>

      <div class="chipDrop">
        <mat-chip-list aria-label="Filters">
          <mat-chip (click)=selectSectionHeading.open() color="primary" selected>
            {{(selectedSectionHeading ? selectedSectionHeading : 'All Section Headings') | unescape}} <fa-icon
              [icon]="faSortDown"></fa-icon>
          </mat-chip>
        </mat-chip-list>
        <mat-select #selectSectionHeading class="optionsDropDown" [(value)]="selectedSectionHeading">
          <mat-option>
            <ngx-mat-select-search [clearSearchInput]="true" [searching]="sectionHeadingsSearching"
              placeholderLabel="Search by Section Heading.." [noEntriesFoundLabel]="noEntries" name="searchValue"
              #searchValue ngModel (ngModelChange)="findSectionHeadings($event)"></ngx-mat-select-search>
          </mat-option>
          <mat-option (click)="resetPagination(); sectionHeadingFilter('')" [value]="">
            All Section Headings
          </mat-option>
          <mat-option [disabled]="searching" *ngFor="let returnedSectionHeading of sectionHeadingsReturned"
            [value]="returnedSectionHeading" (click)="resetPagination();sectionHeadingFilter(returnedSectionHeading)">
            {{returnedSectionHeading | unescape}}
          </mat-option>
        </mat-select>
      </div>

      <div class="chipDrop" *ngIf="evidenceTypeRouter === 'standard'">
        <mat-chip-list aria-label="Filters">
          <mat-chip (click)=selectControlName.open() color="primary" selected>
            {{(selectedControlName ? selectedControlName : 'All Control Names') | unescape}} <fa-icon
              [icon]="faSortDown"></fa-icon>
          </mat-chip>
        </mat-chip-list>
        <mat-select #selectControlName class="optionsDropDown" [(value)]="selectedControlName">
          <mat-option>
            <ngx-mat-select-search [clearSearchInput]="true" [searching]="controlNamesSearching"
              placeholderLabel="Search by Control Name.." [noEntriesFoundLabel]="noEntries" name="searchValue"
              #searchValue ngModel (ngModelChange)="findControlNames($event)"></ngx-mat-select-search>
          </mat-option>
          <mat-option (click)="resetPagination(); controlNameFilter('')" [value]="">
            All Control Names
          </mat-option>
          <mat-option [disabled]="searching" *ngFor="let returnedControlName of controlNamesReturned"
            [value]="returnedControlName" (click)="resetPagination();controlNameFilter(returnedControlName)">
            {{returnedControlName | unescape}}
          </mat-option>
        </mat-select>
      </div>

      <!-- Control name, seciton heading etc -->

      <div class="chipDrop">
        <mat-chip-list aria-label="Filters">
          <mat-chip (click)=storeSelect.open() color="primary" selected>
            <span *ngIf="selectedStore['Location_Name'] === 'All Stores' && user['division'] !== 'DC'">
              All Stores
            </span>
            <span *ngIf="selectedStore['Location_Name'] === 'All Stores' && user['division'] === 'DC'">
              All DCs
            </span>
            <span *ngIf="selectedStore['Location_Name'] !== 'All Stores'">
              {{selectedStore['Store_No']}} - {{selectedStore['Location_Name'] | unescape}}
            </span>
            <fa-icon [icon]="faSortDown"></fa-icon>
          </mat-chip>
          <mat-select #storeSelect class="optionsDropDown" [(value)]="selectedStore">
            <mat-option>
              <ngx-mat-select-search [clearSearchInput]="true" [searching]="searching"
                placeholderLabel="Search by Store Name or Number" [noEntriesFoundLabel]="noEntries" name="searchValue"
                #searchValue ngModel (ngModelChange)="searchForStores($event)"></ngx-mat-select-search>
            </mat-option>
            <mat-option (click)="resetPagination(); setStore()" [value]="">
              All {{user['division'] === 'DC' ? 'DCs' : 'Stores'}}
            </mat-option>
            <mat-option [disabled]="searching" *ngFor="let returnedStore of storesReturned"
              (click)="resetPagination(); setStore(returnedStore)" [value]="returnedStore">
              {{returnedStore['Store_No']}} - {{returnedStore['Location_Name'] | unescape}}
            </mat-option>
          </mat-select>
        </mat-chip-list>
      </div>

      <div class="chipDrop" *ngIf="showReset()">
        <mat-chip-list aria-label="Filters">
          <mat-chip class="clear-chip" (click)="resetFilters()" color="primary" selected>
            <fa-icon class="chip-left-icon" [icon]="faRedoAlt"></fa-icon>
            <span>Clear</span>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </div>
  <div class="audit-tool-cards-container">
    <div class="audit-tool-card more-list-screen-card">



      <mat-tab-group #tabGroup dynamicHeight="false" mat-align-tabs="left" animationDuration="0ms" [(selectedIndex)]="selectedTab"
        (selectedTabChange)="tabChanged($event)">
        <mat-tab label="{{(evidenceGroup | titlecase)}}" *ngFor="let evidenceGroup of evidenceGroups">
          <!-- Evidence Header with Toggle Controls -->
          <div class="evidence-header-container">
            <div class="evidence-heading">
              <span>Evidences</span>
            </div>
            <div class="view-toggle-container">
              <div class="view-toggle-buttons">
                <button 
                  mat-button 
                  [class.active]="viewMode === 'list'" 
                  (click)="toggleViewMode('list')"
                  matTooltip="List View" 
                  class="view-toggle-btn"
                >
                  <fa-icon [icon]="faList"></fa-icon>
                </button>
                <button 
                  mat-button 
                  [class.active]="viewMode === 'thumbnail'" 
                  (click)="toggleViewMode('thumbnail')"
                  matTooltip="Thumbnail View" 
                  class="view-toggle-btn"
                >
                  <fa-icon [icon]="faTh"></fa-icon>
                </button>
              </div>
            </div>
          </div>
          
          <!-- List View -->
            <div *ngIf="viewMode === 'list'" class="view-content">
            <app-evidence-list-view 
              [evidenceData]="evidenceToShow[evidenceType]?.slice(index, index + pageSize) || []"
              [isLoading]="isLoading" 
              [noEvidenceMessage]="noEvidence[evidenceType]"
              [tableColumnObject]="tableColumnObject"
              [tableKeys]="tableKeys"
              [evidenceType]="evidenceTypeRouter"
              (evidenceClick)="onListClick($event)">
            </app-evidence-list-view>
            </div>

            <!-- Thumbnail View -->
            <div *ngIf="viewMode === 'thumbnail'" class="view-content">
            <app-evidence-thumbnail-view 
              [evidenceData]="evidenceToShow[evidenceType]?.slice(index, index + pageSize) || []"
              [isLoading]="isLoading" 
              [noEvidenceMessage]="noEvidence[evidenceType]"
              [evidenceType]="evidenceTypeRouter"
              (evidenceClick)="onThumbnailClick($event)">
            </app-evidence-thumbnail-view>
            </div>

          <!-- Shared Paginator -->
          <div class="paginator-container">
            <mat-paginator #paginator 
              [pageIndex]="pageIndex" 
              [pageSize]="pageSize" 
              [length]="totalCount"
              [pageSizeOptions]="[5, 10, 25, 100]" 
              [showFirstLastButtons]=false 
              (page)="getNext($event)">
            </mat-paginator>
          </div>
        </mat-tab>
      </mat-tab-group>

    </div>
  </div>
</div>